import { useEffect, useRef, useState } from "react";
import { getInstantWinPrizeDetails } from "../../../dreamCar-service";
import { InstantWinPrizeDetails, PrizeTicket } from "../types";
import ReactPaginate from "react-paginate";

const InstantWinWinnerPopup = ({
  make,
  model,
  amountWon,
  amountLeft,
  imageURL,
  barWidth,
  prizeId,
  competitionId,
}: {
  make: string;
  model: string;
  amountWon: number;
  amountLeft: number;
  imageURL: string;
  barWidth: string;
  prizeId: number;
  competitionId: number;
}) => {
  const [currentPageIndex, setCurrentPageIndex] = useState<number>(0);
  const [toBeWonPlacesOrWinners, setToBeWonPlacesOrWinners] = useState<PrizeTicket[]>([]);
  const totalPages = useRef(0);

  useEffect(() => {
    (async () => {
      const response = await getInstantWinPrizeDetails(prizeId, currentPageIndex, competitionId, 10);
      const { Tickets, TotalPages } = (await response.json()) as InstantWinPrizeDetails;
      totalPages.current = TotalPages;
      setToBeWonPlacesOrWinners(Tickets);
    })();
  }, [currentPageIndex]);

  return (
    <>
      <div className="instant-win-prize-popup">
        <div className="flex mt-5">
          <img src={imageURL} alt={`${make}-${model}`} width={150} height={80} />
          <div className="ml-2">
            <h2 className={`text-[24px] font-jost text-ellipsis text-[#28282b]`} style={{ color: "#28282B" }}>
              {make}
            </h2>
            <h5 className={`text-[18px] text-ellipsis text-[#898994]`} style={{ fontSize: "0.75rem" }}>
              {model}
            </h5>
          </div>
        </div>
        <div className="flex justify-between mt-5">
          <div className="flex prizesWon flex-col">
            <div className="flex">
              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4" cy="4" r="4" fill="#FF8200" />
              </svg>
              <span className="ml-1 leading-[0.5] text-[14px] text-[#898994]">Won</span>
            </div>
            <span className="font-jost text-[24px] font-normal text-[#696971]">{amountWon}</span>
          </div>
          <div className="flex prizesLeft flex-col">
            <div className="flex">
              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4" cy="4" r="4" fill="#FFD8B0" />
              </svg>
              <span className="ml-1 leading-[0.5] text-[14px] text-[#898994]">Left</span>
            </div>
            <span className="font-jost text-[24px] font-normal text-[#696971]">{amountLeft}</span>
          </div>
        </div>
        <div className="w-full bg-[#ffd8b0] rounded-full h-2 mt-2">
          <div className={`bg-[#ff8200] h-2 rounded-full ${barWidth}`}></div>
        </div>
        <div className="mt-5">
          {toBeWonPlacesOrWinners.map((toBeWonOrWinnerPlace: PrizeTicket, index: number) => (
            <div key={index} className="flex mb-4">
              <span className="basis-4">{index + 1}.</span>
              <div
                className={`${toBeWonOrWinnerPlace.DateWon ? "bg-[silver] xs:basis-44 md:basis-24" : "bg-[#ff8200] basis-24"} flex rounded-[4.8px] ml-3`}>
                <div className="border-r-[1.2px] border-dotted border-white basis-4"></div>
                <div className="text-white mx-1">{toBeWonOrWinnerPlace.InstantWinRef}</div>
              </div>
              <span className={`${toBeWonOrWinnerPlace.DateWon ? "text-[#4c4c52]" : "text-[#ff8200]"} ml-2 basis-64`}>
                {toBeWonOrWinnerPlace.DateWon ? toBeWonOrWinnerPlace.WinnerName : "To be won"}
              </span>
              {toBeWonOrWinnerPlace.DateWon && (
                <span className="text-[#898994] whitespace-nowrap ml-auto">{toBeWonOrWinnerPlace.DateWon}</span>
              )}
            </div>
          ))}
        </div>
        <ReactPaginate
          initialPage={0}
          breakLabel="..."
          nextLabel=">"
          onPageChange={event => setCurrentPageIndex(event.selected)}
          pageRangeDisplayed={3}
          pageCount={toBeWonPlacesOrWinners.length}
          previousLabel="<"
          renderOnZeroPageCount={null}
          containerClassName="flex justify-center items-center mt-5"
          pageClassName="border-solid border-[#e0e0e0] border-[1px] rounded-md w-[32px] h-[32] text-[#4c4c52] mx-1 text-center"
          activeClassName="bg-[#ff8200] text-white"
          previousClassName="border-solid border-[#e0e0e0] border-[1px] rounded-md w-[32px] h-[32] text-[#4c4c52] mx-1 text-center"
          nextClassName="border-solid border-[#e0e0e0] border-[1px] rounded-md w-[32px] h-[32] text-[#4c4c52] mx-1 text-center"
          disabledClassName="bg-[#f0f0f0] text-[#b0b0b0] pointer-events-none"
        />
      </div>
    </>
  );
};

export default InstantWinWinnerPopup;
